import { Box, Grid, Skeleton, Tooltip } from "@mui/material";
import { Icons } from "assets";
import classNames from "classnames";
import RangeDatePicker from "../rangeDatePicker";
import styles from "./style.module.scss";

interface StatsCardProps {
  statsList: any;
  label?: string;
  isDateRequired?: boolean;
  startDate?: any;
  setStartDate?: any;
  endDate?: any;
  setEndDate?: any;
  loader?: boolean;
}

function StatsCard({
  statsList,
  label,
  isDateRequired,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  loader,
}: StatsCardProps) {
  return (
    <>
      <Box className={styles.statsContainer}>
        <div className={styles.labelContainer}>
          {label && <div className={styles.statsHeading}>{label}</div>}
          <div style={{ display: "flex" }}>
            {isDateRequired && (
              <div className={styles.gridCenter}>
                <RangeDatePicker
                  startDate={startDate}
                  setStartDate={setStartDate}
                  endDate={endDate}
                  setEndDate={setEndDate}
                  labelStyle={styles.dateLabel}
                />
              </div>
            )}
          </div>
        </div>

        <Grid container className={styles.mainGrid} spacing={2}>
          {statsList?.map((item: any) => {
            let stats = item?.stats;
            return (
              <Grid item xs={12} md={6} lg={4}>
                <div className={styles.singleStatsCard}>
                  <div className={styles.statsLabel}>
                    {loader ? (
                      <Skeleton variant="rectangular" width={200} height={20} />
                    ) : (
                      item?.label
                    )}
                  </div>
                  <div className={styles.statsCount}>
                    {loader ? (
                      <Skeleton variant="rectangular" width={50} height={40} />
                    ) : (
                      item?.count?.toLocaleString()
                    )}
                  </div>
                  {stats && (
                    <div
                      className={classNames(
                        styles.statsInnerContainer,
                        styles.index
                      )}
                    >
                      <span
                        style={{
                          marginRight: "4px",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        {stats?.index ? <Icons.IndexUp /> : <Icons.IndexDown />}
                      </span>
                      <span
                        style={{ marginRight: "8px" }}
                        className={
                          stats?.index ? styles.indexUp : styles.indexDown
                        }
                      >
                        100%
                      </span>
                      <span className={styles.indexLabel}>vs last month</span>
                      <span className={styles.graphIconContainer}>
                        {stats?.index ? <Icons.GraphUp /> : <Icons.GraphDown />}
                      </span>
                    </div>
                  )}
                </div>
              </Grid>
            );
          })}
        </Grid>
      </Box>
    </>
  );
}

export default StatsCard;
